import * as React from 'react';
import { useEffect, useState } from 'react';
import PositionTable from './positions';
import ResourceTable from './resources';


const SelectedTables = (props: any) => {
     
  let products: {candidateId: string, allocatedTo: string}[] = props.data

  const [dataState, setDataState] = useState(  products && products.map((dataItem: any) =>
    Object.assign({ selected: false }, dataItem._source)    
  ));

  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedState, setSelectedState] = useState<{
    [id: string]: boolean | number[];
  }>({});
  

  useEffect(() => {
    setDataState(products && products.map((dataItem: any) =>
      Object.assign({ selected: false }, dataItem._source) 
    ))
  }, [products])

  return (
    <div className="tableStyle">
        { props && props.type === 'positions' && <PositionTable dataState={dataState} selectedState={selectedState} state={props.state} data={props.data} total={props.total}  pageChange={props.pageChange}  pageSize={props.pageSize} onSelection={props.onSelection} onRowClick={props.onRowClick}/>  }
        { props && props.type === 'resources' && <ResourceTable dataState={props.data} selectedState={selectedState} state={props.state} data={props.data} total={props.total}  pageChange={props.pageChange}  pageSize={props.pageSize} onSelection={props.onSelection} onRowClick={props.onRowClick}/>  }
    </div>
  );
};
export default SelectedTables;


